<template>
    <div v-if="visible" class="top-banner">
        <p class="banner-text">
            🎁 <strong style="color: white">¡Activa HOY tu control de stock y obtén 3 meses GRATIS!</strong>
            <span @click="sendMessage()" class="banner-link">👉 Aprovechar oferta limitada</span>
        </p>

        <button class="banner-close" @click="closeBanner">✖</button>
    </div>
</template>
  
<script>
  export default {
    name: "TopBanner",
  
    data() {
      return {
        //visible: true,
      };
    },
    
    props: {
        visible: {
            type: Boolean,
            default: false //true
        }
    },

    methods: {
      closeBanner() {
        this.visible = false;
        //this.$emit("closed");
      },
      sendMessage() {
        const mensaje = encodeURIComponent(`Buen día, quisiera obtener más información sobre la herramienta de Control de Stock.`);
        const whatsappURL = `https://wa.me/51975818189?text=${mensaje}`;
        window.open(whatsappURL, "_blank");
      }
    },
  };
</script>
  
<style scoped>
.top-banner {
  width: 100%;
  background-color: #4f46e5; /* Indigo */
  color: white;
  padding: 8px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.banner-text {
  font-size: 14px;
  font-weight: 500;
  margin: 0;
}

.banner-link {
  text-decoration: underline;
  cursor: pointer;
}

.banner-close {
  position: absolute;
  right: 12px;
  background: none;
  border: none;
  color: white;
  font-size: 16px;
  cursor: pointer;
}

.banner-close:hover {
  color: #ddd;
}
</style>


// WEBPACK FOOTER //
// TopBanner.vue?c66e809e